<template>
  <b-table :data="projects">
    <b-table-column
      field="name"
      label="Name"
      v-slot="props"
      sortable
      :searchable="isSearchable"
    >
      {{ props.row.name }}
    </b-table-column>

    <b-table-column
      field="start_date"
      label="Start Date"
      v-slot="props"
      sortable
    >
      {{ new Date(props.row.start_date).toLocaleDateString() }}
    </b-table-column>

    <b-table-column field="end_date" label="End Date" v-slot="props" sortable>
      {{ new Date(props.row.end_date).toLocaleDateString() }}
    </b-table-column>

    <b-table-column field="is_active" label="Status" sortable v-slot="props">
      <b-tag :type="rowType(props.row.status)">
        {{ props.row.status }}
      </b-tag>
    </b-table-column>

    <b-table-column
      class="progressfield"
      field="progress"
      label="Progress"
      v-slot="props"
      sortable
    >
      <ColourCodedProgressBar :number="props.row.progress" />
    </b-table-column>
    <b-table-column label="Actions" v-slot="props">
      <inertia-link
        :href="route('projects.show', props.row.unique_id)"
        v-if="!props.row.deleted_at"
      >
        <b-button type="is-primary" size="is-small">Edit</b-button>
      </inertia-link>
      <inertia-link
        :href="route('projects.restore', props.row.unique_id)"
        method="patch"
        v-else
      >
        <b-button type="is-success" size="is-small">Restore</b-button>
      </inertia-link>
      <b-button
        label="Reports"
        type="is-warning"
        size="is-small"
        @click="toggleReportModal(props.row)"
      />
    </b-table-column>

    <b-modal
      v-model="isDownloadReportsModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <DownloadReportsModal :project="openProject" />
    </b-modal>
  </b-table>
</template>

<script>
import DownloadReportsModal from '../../Components/Management/DownloadReportsModal';
import ColourCodedProgressBar from '../../Components/Management/ColourCodedProgressBar';

export default {
  components: {
    DownloadReportsModal,
    ColourCodedProgressBar,
  },
  props: {
    projects: Array,
  },
  data() {
    return {
      isDownloadReportsModalActive: false,
      openProject: null,
    };
  },
  computed: {
    isSearchable: function () {
      return this.projects.length > 10;
    },
  },
  methods: {
    toggleReportModal(project) {
      this.openProject = project;
      this.isDownloadReportsModalActive = !this.isDownloadReportsModalActive;
    },
    rowType(status) {
      if (status === 'Open') {
        return 'is-success';
      } else if (status === 'Closed') {
        return 'is-danger';
      } else {
        return 'is-warning';
      }
    },
  },
};
</script>
